//
// SelectionControl.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseUIModel";
import "./SelectionControlItem";

var SelectionControl = createModule("commons_SelectionControl", [130,13,10004,10071], EventDispatcher, [
    {
        REMOVE_TERM: 20053,
        SELECTION_CONTROL_CHANGE: 20051,
        REMOVE_ITEM: 20052,
    },
    {
        items: [1],
    },
    ,
    ,
    {
        updateSelection: [0,1,1,1,2,[1]],
        removeItems: [0,[1]],
        clear: [0],
        removeTerms: [0,[1]],
    },
    {
        _create: [4],
    },
    ,
]);
export default SelectionControl;
